<app-de-wrapper>
  <div class="page-icon-tp">
    <app-zaver-icon [size]="86" name="tpCircle" ></app-zaver-icon>
  </div>

  <h1 class="heading">
    Aktivera betalmetoden Faktura hos
    {{ state.checkoutCustomizations.merchantName }}
  </h1>

  <ng-container
    *ngIf="
      state.zaverProduct ===
      ZAVERPRODUCT.SE_TOKENIZED_ONBOARDING_CREDIT_WITH_PAYMENT
    "
  >
    <!--change the onboarding with payment  -->
    <hr class="details-divider" />

    <div class="details-container">
      <div class="details-key-entry">{{ state.paymentInformation?.title }}</div>
      <div class="details-value-entry">
        <zaver-button-link
          [text]="'Detaljer om ditt köp'"
          (click)="showPurchaseInformation()"
        ></zaver-button-link>
      </div>
    </div>

    <hr class="details-divider" />

    <div class="details-container">
      <div class="details-key-entry">Totalbelopp</div>
      <div class="details-value-entry details">
        {{ state.totalCheckoutValue | value }}
      </div>
    </div>
  </ng-container>

  <div class="button-container">
    <zaver-primary-button
      [buttonType]="'submit'"
      [text]="'Slutför'"
      (click)="handleCtaClick()"
      [logo]="'assets/icon/BankID-Vector-Logo-White.svg'"
    ></zaver-primary-button>
  </div>
  <div class="terms-button-container">
    <zaver-button-link
      [text]="'Visa villkor'"
      (click)="showTerms()"
    ></zaver-button-link>
  </div>
</app-de-wrapper>

<zaver-checkout-modal
  *ngIf="selectorItems && modalActive"
  [buttonText]="'Stäng'"
  [title]="'Visa detaljer'"
  (onClose)="toggleModal()"
>
  <app-selector
    #selector
    [selectorItems]="selectorItems"
    [selectedItem]="selectedItem"
  ></app-selector>
</zaver-checkout-modal>
